import { render, staticRenderFns } from "./VisitRequestProposal.vue?vue&type=template&id=5145b7b0&scoped=true"
import script from "./VisitRequestProposal.vue?vue&type=script&lang=js"
export * from "./VisitRequestProposal.vue?vue&type=script&lang=js"
import style0 from "./VisitRequestProposal.vue?vue&type=style&index=0&id=5145b7b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5145b7b0",
  null
  
)

export default component.exports